import {
  createReducer,
} from 'reduxsauce';
import _ from 'lodash';
import { MAIN_REDUX_TYPES, MAIN_REDUX_INITIAL_STATE } from '../actions/mainAction';

/* ------------- Reducers ------------- */

export const setMainRedux = (state, { key, data }) => {
  return _.cloneDeep({
    ...state,
    [key]: data,
  });
}

/* ------------- Hookup Reducers To Types ------------- */

export const mainReducer = createReducer(MAIN_REDUX_INITIAL_STATE, {
  [MAIN_REDUX_TYPES.SET_MAIN_REDUX]: setMainRedux,
})